import React, { Component } from "react";

import EvaluationDetail from "./EvaluationDetail";

class Evaluation extends Component {
  state = {};

  renderContent() {
    const { templateType, ...rest } = this.props;
    return <EvaluationDetail {...rest} />;
  }

  render() {
    return <div style={{ marginBottom: 24 }}>{this.renderContent()}</div>;
  }
}

export default Evaluation;
